import React, { FC } from 'react';
import { Section } from 'omni-package-react-core';
import { useTranslation } from 'react-i18next';
import { PersonalInformation } from '../../../../interfaces/PersonalInformation';
import Email from './Email';

export interface EmailsProps {
  personalInfo: PersonalInformation;
}
const Emails: FC<EmailsProps> = ({ personalInfo }) => {
  const { t } = useTranslation('PersonalInformationsTile');

  if (!personalInfo || !personalInfo?.emails) return null;
  if (personalInfo.emails.home === '' && personalInfo.emails.work === '') return null;
  if (!personalInfo.emails.behaviours.showSection) return null;

  return (
    <Section name={t('emails.title')}>
      <Email personalInfo={personalInfo} />
    </Section>
  );
};
export default Emails;
